import { Model } from "survey-react"
import { questionFactory } from "./Languages/LanguageSelector"

export const returnType = (num1:number,num2:number,num3:number,num4:number)=>{
    let largest_num = Math.max(num1,num2,num3,num4)

    switch (largest_num) {
        case num1:
            return 'Limited'
        case num2:
            return 'Shifting'
        case num3:
            return 'Shifted'
        case num4:
            return 'Widespread'
            
    
        default:
            return 'Limited'
            
    }

}
export const returnSurveyType = (value:string)=>{
    let intValue = parseInt(value) 
    console.log(intValue)
    switch (intValue) {
        case 1:
            return 'Limited'
        case 2:
            return 'Shifting'
        case 3:
            return 'Shifted'
        case 4:
            return 'Widespread'
        default:
            return 'unknown'
    }
}
export const returnReplaceValue = (value:string)=>{
    //if value is a number return the number
    if(!isNaN(parseInt(value))){
        return returnSurveyType(value)
    }else{
        return value
    }
}




 const storeOnLocalStorageTimesRefreshed = (timesRefreshed:number)=>{
    localStorage.setItem('timesRefreshed',timesRefreshed.toString());
}

 const getFromLocalStorageTimesRefreshed = ()=>{
    return localStorage.getItem('timesRefreshed')
}

export const limitedPageRefresh = ()=>{
    if(Number(getFromLocalStorageTimesRefreshed())>=3){
        return;
    }else{
        window.location.reload()
        storeOnLocalStorageTimesRefreshed(Number(getFromLocalStorageTimesRefreshed())+1);
    }
}

 const storeDate = ()=>{
    const date = new Date().toLocaleDateString()
    localStorage.setItem('date',date)
}
 const clearTimesRefreshed = ()=>{
    localStorage.setItem('timesRefreshed','0')
}
export const newDayClearRefreshed = ()=>{
    if(localStorage.getItem('date')!==new Date().toLocaleDateString()){
        clearTimesRefreshed()
        storeDate()
    }
}
export const fetchUrlData = async <T>(url: string): Promise<[T | null, unknown | null]>=>{
    try {
    let response = await fetch(url);
    let data = await response.json() as T;
    return [data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getSurveyModel = (languageId:number)=>{
    let save_data = window.localStorage.getItem("my-survey");
    const survey = new Model(questionFactory(languageId));
    if (save_data) {
        let data = JSON.parse(save_data);
        survey.data = data;
    }
    return survey;
}

export const markdownToHTML = (markdown:string)=> {
    return markdown
        // Replace headings
        .replace(/###### (.*?)(\n|$)/g, '<h6>$1</h6>')
        .replace(/##### (.*?)(\n|$)/g, '<h5>$1</h5>')
        .replace(/#### (.*?)(\n|$)/g, '<h4>$1</h4>')
        .replace(/### (.*?)(\n|$)/g, '<h3>$1</h3>')
        .replace(/## (.*?)(\n|$)/g, '<h2>$1</h2>')
        .replace(/# (.*?)(\n|$)/g, '<h1>$1</h1>')

        // Replace bold (**text** or __text__)
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/__(.*?)__/g, '<strong>$1</strong>')

        // Replace italic (*text* or _text_)
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/_(.*?)_/g, '<em>$1</em>')

        // Replace inline code (`code`)
        .replace(/`(.*?)`/g, '<code>$1</code>')

        // Replace links ([text](url))
        .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>')

        // Replace unordered lists (- or *)
        .replace(/(?:^|\n)[-|\*] (.*?)(\n|$)/g, '<li>$1</li>')
        .replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>')

        // Replace ordered lists (1. 2. 3.)
        // .replace(/(?:^|\n)\d+\. (.*?)(\n|$)/g, '<li>$1</li>')
        // .replace(/(<li>.*?<\/li>)+/g, '<ol>$&</ol>')

        // Replace blockquotes (lines starting with >)
        .replace(/(?:^|\n)> (.*?)(\n|$)/g, '<blockquote>$1</blockquote>')

        // Replace horizontal rules (--- or ***)
        .replace(/(?:^|\n)(?:---|\*\*\*)(\n|$)/g, '<hr>')

        // Replace line breaks (two spaces at the end of a line)
        .replace(/  \n/g, '<br>')
        .replace(/Guidance/g, '<br><br>Guidance<br>')
        .replace(/Scripture Translation Recommendations/g, '<br><br>Scripture Translation Recommendations<br>')

}